(ns dre.components.loading-spinner
  (:require [dre.components.icon :refer [fa-icon]]))

(defn loading-spinner
  []
  [:div.icon
   [fa-icon :spinner {:spin true
                      :size "2xl"}]])

(defn full-size-loading-spinner
  []
  [:div
   {:class :full-size-loading-spinner}
   [loading-spinner]])

(defn full-size-loading-spinner-overlay
  []
  [:div
   {:class :full-size-loading-spinner-overlay}
   [loading-spinner]])
